import { render, staticRenderFns } from "./ModalPublish.vue?vue&type=template&id=6c3e20cd&scoped=true&"
import script from "./ModalPublish.vue?vue&type=script&lang=js&"
export * from "./ModalPublish.vue?vue&type=script&lang=js&"
import style0 from "./ModalPublish.vue?vue&type=style&index=0&id=6c3e20cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e20cd",
  null
  
)

export default component.exports